import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { services } from '../data/services';
export function Services() {
  return <section id="services" aria-labelledby="services-heading" className="w-full bg-white" data-id="element-270" data-mp="1hwffqtvz2vz3">
      <div className="mx-auto max-w-shell px-[18px] py-12 sm:px-6 lg:py-20" data-id="element-271" data-mp="1dshhsmidvr7m">
        <div className="max-w-[640px]" data-id="element-272" data-mp="18twgskvb53i4">
          <h2 id="services-heading" className="text-[28px] font-bold leading-tight text-kosin-charcoal lg:text-[36px]" data-id="element-273" data-mp="18x24bvoafxbq">
            Glass Services For Southeast Michigan
          </h2>
          <p className="mt-3 text-[17px] leading-relaxed text-kosin-body" data-id="element-274" data-mp="u61np3de0x4i">
            From a chipped windshield to custom shower glass and storefronts,
            our local team helps you find the right solution.
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:mt-12 lg:grid-cols-4" data-id="element-275" data-mp="l423y3aznexv">
          {services.map(service => <article key={service.key} className="flex h-full flex-col" data-id="element-276" data-mp="g8mv5pru898b">
              <img src={service.image} alt={service.imageAlt} className="aspect-[4/3] w-full rounded object-cover" loading="lazy" data-id="element-277" data-mp="36b6ew4bb446g" />
              <h3 className="mt-5 text-[21px] font-semibold text-kosin-charcoal" data-id="element-278" data-mp="2x9os633e948s">
                {service.title}
              </h3>
              <p className="mt-2.5 text-[16px] leading-relaxed text-kosin-body" data-id="element-279" data-mp="3q0qdklxojw0r">
                {service.description}
              </p>
              <ul className="mt-4 space-y-2 text-[15px] text-kosin-ink" data-id="element-280" data-mp="3u0r2j0ienpm2">
                {service.bullets.map(bullet => <li key={bullet} className="flex gap-2" data-id="element-281" data-mp="3g4dgrf6u921s">
                    <CheckIcon className="mt-[3px] h-4 w-4 shrink-0 text-kosin-red" aria-hidden="true" data-id="element-282" data-mp="3l0b07udeeois" />
                    <span data-id="element-283" data-mp="29lxh12tlax93">{bullet}</span>
                  </li>)}
              </ul>
              <a href={service.href} className="mt-auto inline-flex items-center gap-1.5 pt-5 text-[15px] font-semibold text-kosin-red hover:text-kosin-bright transition-colors duration-150 ease-kosin" data-id="element-284" data-mp="1pjuhl9nv90ez">
                {service.linkLabel}
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-285" data-mp="1bspfm0x0zw1h" />
              </a>
            </article>)}
        </div>
      </div>
    </section>;
}